module.exports = __webpack_public_path__ + "static/media/34_B.6d32da67.png";